import React from 'react';

import { Switch, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { Check, X } from 'react-feather';

import { useMenuManagement } from 'hooks/useMenuManagement';

export default function RecordEnabledSwitch({ record }) {
  const { updateCubohMenu } = useMenuManagement();

  const handleSave = async event => {
    await updateCubohMenu({
      group: record.itemType,
      id: record.key,
      data: { ...record, enabled: event },
    });
  };
  return (
    <Tooltip
      title={
        (!record.noEdit && record.parentMenus?.length > 1) || record.associatedMerchants?.length
          ? 'Enabled/Disabled changes on the master menu do not apply to the clones. Please access cloned menus to update them.'
          : null
      }
    >
      <Switch
        checked={record.enabled}
        checkedChildren={<Check size={10} className="icon-spacing" />}
        unCheckedChildren={<X size={10} className="icon-spacing" />}
        onClick={event => handleSave(event)}
      />
    </Tooltip>
  );
}

RecordEnabledSwitch.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  record: PropTypes.object.isRequired,
};
